module.exports = __webpack_public_path__ + "img/b_Sink_2.56304fcc.jpeg";